import { combineReducers } from 'redux';

import { CANCEL_CONFIRM_LOCATION, CONFIRM_LOCATION, CONFIRM_LOCATION_ERROR, CONFIRM_LOCATION_SUCCESS } from './LocationExpiry.actions';

const loading = (state = false, action) => {
  switch(action.type) {
    case CONFIRM_LOCATION:
      return true;
      
    case CONFIRM_LOCATION_SUCCESS:
    case CONFIRM_LOCATION_ERROR:
    case CANCEL_CONFIRM_LOCATION:
      return false;

    default:
      return state;
  }
};

const reducer = combineReducers({
  loading
});

reducer.reducer = 'locationExpiry';

export default reducer;
